import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ExperienceStyle } from '@ess-front/shared';
import { EditorialContent } from '@shared/models/be-experience.model';
import { StaticTextKey } from '@shared/models/static-text-key.model';

@Component({
  selector: 'ess-experience-editor-view',
  templateUrl: './experience-editor-view.component.html',
  styleUrls: ['./experience-editor-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExperienceEditorViewComponent {
  tags = input<StaticTextKey[]>([]);
  editorialContent = input<EditorialContent[]>([]);
  description = input<string>('');
  experienceStyle = input<string | null>(null);
  benefits = input.required<string>();

  ExperienceStyle = ExperienceStyle;
}
